import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import { Typography } from '../../../theme/Typography.es.js';
import 'react';
import { boxSizing } from '../../../style-mixins/reset.es.js';

const Styles = labelStyles("TableHeadHeading", {
  root: css`
    ${boxSizing};
    display: flex;
    align-items: center;
    color: ${Colors.TextDefault};
    ${Typography.SmallPrint2};
  `
});
const TableHeadHeading = (props) => {
  return jsx("span", { css: Styles.root }, props.children);
};

export { TableHeadHeading };
//# sourceMappingURL=TableHeadHeading.es.js.map
